import React from 'react';
import PropTypes from 'prop-types';
import AppErrorFallback from './AppErrorFallback';

// App-wide error boundary — any uncaught render/lifecycle error shows the
// friendly "Oops" screen with a Refresh action instead of a white screen.
class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Surface in console for diagnostics — the UI itself stays friendly
    console.error('Unhandled render error:', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="tw-min-h-screen tw-w-full tw-flex tw-items-center tw-justify-center tw-bg-slate-50">
          <AppErrorFallback />
        </div>
      );
    }
    return this.props.children;
  }
}

AppErrorBoundary.propTypes = { children: PropTypes.node };

export default AppErrorBoundary;
